<template>
  <v-app>
    <v-main>
      <div id="main">
        <v-col class="ad-column d-md-block d-none">
          <Adsense
            data-ad-client="ca-pub-5150261809463519"
            data-ad-slot="1617515687"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></Adsense>
        </v-col>
        <v-col>
          <v-row class="justify-content-center">
            <google-ad unit="300_250_unit" />
          </v-row>
          <v-row>
            <v-card
              elevation="0"
              style="background-color: #f7faff; padding-bottom: 15px; margin-right: 50px"
            >
              <v-row>
                <v-col cols="auto">
                  <img id="logo" :src="logoUrl" />
                </v-col>

                <v-col>
                  <v-card-title>
                    {{ submissionConfirmationText }}
                  </v-card-title>

                  <v-card-subtitle>
                    {{ pageName }}
                  </v-card-subtitle>
                </v-col>
              </v-row>

              <v-card-actions>
                <v-btn
                  :v-if="newSubmissionButtonEnabled"
                  :href="submitAgainUrl"
                  :style="`color: black !important; margin-right: 10px;`"
                  >Submit Again</v-btn
                >
                <v-btn
                  :v-if="submissionTrackerEnabled"
                  :href="mySubmissionsUrl"
                  class="button"
                  :style="
                    `color:${buttonTextColor} !important; background-color:${buttonColor} !important; margin-left: 10px;`
                  "
                  >My Submissions</v-btn
                >
                <v-btn
                  :v-if="hallOfFameEnabled"
                  :href="hallOfFameUrl"
                  class="button"
                  :style="
                    `color:${buttonTextColor} !important; background-color:${buttonColor} !important; margin-left: 10px;`
                  "
                >
                  {{ pageName }} Hall of Fame
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-row>
          
          <v-row class="justify-content-center">
            <google-ad unit="300_250_unit" />
          </v-row>
        </v-col>
        <v-col class="ad-column d-md-block d-none">
          <Adsense
            data-ad-client="ca-pub-5150261809463519"
            data-ad-slot="1617515687"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></Adsense>
        </v-col>
      </div>
    </v-main>
  </v-app>
</template>
<script>
export default {
  props: {
    "logo-url": String,
    "submission-confirmation-text": String,
    "page-name": String,
    "button-color": String,
    "button-text-color": String,
    "submit-again-url": String,
    "track-submission-url": String,
    "my-submissions-url": String,
    "submission-tracker-enabled": String,
    "new-submission-button-enabled": String,
    "hall-of-fame-url": String,
    "hall-of-fame-enabled": Boolean,
  },
};
</script>
<style scoped>
/*  content padding/margins need to be removed
    for mobile styling not to have a border
*/
html,
body {
  height: 100%;
}

#content {
  padding: 10px;
}

#main {
  display: flex;
  width: 90vw;
  justify-content: space-around;
}

#logo {
  height: 80px;
  width: 80px;
}

#submitted-wrapper {
  display: flex;
  justify-content: center;
}

#text-wrapper {
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
}

#buttons {
  margin-bottom: 10px;
}

.ad-column {
  min-width: 200px;
}
</style>
